// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormItem_root_2U-wj{display:flex;margin-bottom:32px;align-items:center}.FormItem_root_2U-wj.FormItem_vertical_2FXv-{display:block}.FormItem_root_2U-wj.FormItem_vertical_2FXv- .FormItem_title_ukEpr{margin-bottom:8px;width:auto}.FormItem_title_ukEpr{width:190px;color:#8391a2}.FormItem_slot_2Ce8n{flex-grow:1}", ""]);
// Exports
exports.locals = {
	"root": "FormItem_root_2U-wj",
	"vertical": "FormItem_vertical_2FXv-",
	"title": "FormItem_title_ukEpr",
	"slot": "FormItem_slot_2Ce8n"
};
module.exports = exports;
